import { GET_ALL_DATA, SET_CALENDAR_LOADING, GET_EVENT } from './calendarTypes'

const initialState = {
  calendarData: [],
  calendarEvent: {},
  isLoading: false,
}

export default (state = initialState, action) => {
  switch (action.type) {
    case GET_EVENT:
      return {
        ...state,
        calendarEvent: action.payload,
      }
    case GET_ALL_DATA:
      return {
        ...state,
        calendarData: action.payload,
        isLoading: false,
      }
    case SET_CALENDAR_LOADING:
      return {
        ...state,
        isLoading: !state.isLoading,
      }
    default:
      return state
  }
}
